'use strict';
var React = require('react');

var deviceShellHelper = require('../helper/deviceShellHelper');

var Shell = React.createClass({
  propTypes: {
    size: React.PropTypes.object.isRequired,
    shell: React.PropTypes.string.isRequired,
    isHorizontal: React.PropTypes.bool.isRequired
  },
  render: function () {
    var components;
    var style;
    var bottomAndTopStyle;
    var shell;
    var isHorizontal;
    var className;
    var isMobile;

    shell = this.props.shell;
    isMobile = shell === 'iPhone' || shell === 'Android';
    isHorizontal = this.props.isHorizontal;
    components = deviceShellHelper.getShellComponents({
      type: 'real',
      name: shell
    }, isHorizontal);
    style = {
      width: parseInt(this.props.size.width, 10),
      height: parseInt(this.props.size.height, 10)
    };
    className = 'shell';
    if (isHorizontal) {
      className += ' horizontal';

      bottomAndTopStyle = {
        width: this.props.size.left,
        height: 'auto'
      };
    } else {
      bottomAndTopStyle = {
        width: 'auto',
        height: this.props.size.top
      };
    }

    return (
      <div className={className} style={style}>
        {components.whole && <img className="shell-whole" src={components.whole}/>}
        {isMobile && <img className="shell-top" style={bottomAndTopStyle} src={components.top}/>}
        {isMobile && <img className="shell-home" style={bottomAndTopStyle} src={components.bottom}/>}
      </div>
    );
  }
});

module.exports = Shell;


// WEBPACK FOOTER //
// ./src/views/Shell.jsx